export type AmbientKind = 'bubbles' | 'plankton' | 'leaves' | 'snow' | 'embers' | 'dust' | 'ash' | 'steam' | 'data' | 'shards';
export type LandmarkKind = 'vent' | 'reef' | 'fossils' | 'iceArch' | 'stones' | 'ruins' | 'gate' | 'boiler' | 'holo' | 'hourglass';

export interface EnvironmentProfile {
  landmark: LandmarkKind;
  ambient: AmbientKind;
  ambientColor: number;
  ambientCount: number;
  /** Presentation-only seam for a later free/CC0 authored landmark set. */
  gltf?: string;
  motif: 'veins' | 'currents' | 'tracks' | 'wind' | 'char' | 'mosaic' | 'cobbles' | 'rails' | 'lanes' | 'fractures';
}

export const ENVIRONMENT_PROFILES: readonly EnvironmentProfile[] = [
  { landmark: 'vent', ambient: 'bubbles', ambientColor: 0x83ffe4, ambientCount: 90, motif: 'veins' },
  { landmark: 'reef', ambient: 'plankton', ambientColor: 0x63f7ff, ambientCount: 100, motif: 'currents' },
  { landmark: 'fossils', ambient: 'leaves', ambientColor: 0xc7d55a, ambientCount: 70, motif: 'tracks' },
  { landmark: 'iceArch', ambient: 'snow', ambientColor: 0xffffff, ambientCount: 130, motif: 'wind' },
  { landmark: 'stones', ambient: 'embers', ambientColor: 0xff8a32, ambientCount: 65, motif: 'char' },
  { landmark: 'ruins', ambient: 'dust', ambientColor: 0xffd77a, ambientCount: 75, motif: 'mosaic' },
  { landmark: 'gate', ambient: 'ash', ambientColor: 0xbfc4cc, ambientCount: 70, motif: 'cobbles' },
  { landmark: 'boiler', ambient: 'steam', ambientColor: 0xd8d2bd, ambientCount: 80, motif: 'rails' },
  { landmark: 'holo', ambient: 'data', ambientColor: 0x5cf0ff, ambientCount: 120, motif: 'lanes' },
  { landmark: 'hourglass', ambient: 'shards', ambientColor: 0xd786ff, ambientCount: 110, motif: 'fractures' },
];

export function environmentProfile(eraIndex: number): EnvironmentProfile {
  return ENVIRONMENT_PROFILES[Math.max(0, Math.min(ENVIRONMENT_PROFILES.length - 1, eraIndex | 0))];
}
